module.exports = __webpack_public_path__ + "img/02-4方案收益.5c3632ee.png";